import { useState } from "react";
import { Download, Copy, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { fileUrl } from "@/lib/api";

export async function saveToPhone(file) {
  const res = await fetch(fileUrl(file.id), { credentials: "include" });
  if (!res.ok) throw new Error("Download fehlgeschlagen");
  const blob = await res.blob();
  const f = new File([blob], file.name, { type: file.content_type || blob.type });
  if (navigator.canShare?.({ files: [f] })) {
    try { await navigator.share({ files: [f] }); return "shared"; } catch (e) { if (e.name === "AbortError") return "aborted"; }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = file.name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return "downloaded";
}

export function SaveButton({ file, className = "", label = "In Galerie speichern", testId, color = "bg-teal-500" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const r = await saveToPhone(file); if (r === "downloaded") toast.success("Heruntergeladen"); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <button onClick={run} disabled={busy} className={`inline-flex items-center justify-center gap-2 h-11 px-4 rounded-lg ${color} text-slate-950 font-semibold active:scale-[0.97] transition-transform disabled:opacity-70 ${className}`} data-testid={testId || `save-media-${file.id}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}{label}
    </button>
  );
}

export function CopyButton({ text, label, testId }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setDone(true);
    toast.success(`${label || "Text"} kopiert`);
    setTimeout(() => setDone(false), 1800);
  };
  return (
    <button onClick={copy} disabled={!text} className={`inline-flex items-center justify-center gap-1.5 h-11 px-3 rounded-lg border text-sm font-medium transition-colors active:scale-[0.97] disabled:opacity-40 ${done ? "border-emerald-500 text-emerald-400" : "border-border text-slate-200 hover:bg-white/5"}`} data-testid={testId}>
      {done ? <Check className="h-4 w-4 shrink-0" /> : <Copy className="h-4 w-4 shrink-0" />}{label}
    </button>
  );
}
